var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),(_vm.history.length >= 1)?_c('div',[_c('playlist',{attrs:{"tracks":_vm.history,"remove":false}})],1):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("This is the Playlist History")])])
}]

export { render, staticRenderFns }